import VAActionType from '../../common/VAActionType';

const initialState = {};

const VAReducer = (state = initialState, action) => {
  if (action.type === VAActionType.GET_VA_CONFIG) {
    return { ...state, config: action.response };
  }
  return state;
};

export const VASelector = {
  getVAConfig: state => state.va.config
};

export default VAReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/VAReducer.js
 **/